<template>
    <nav class="mobile-bottom-nav">
        <div class="nav-inner">
            <div
                v-for="(item, i) in navItems"
                :key="item.key"
                class="nav-item-wrap"
            >
                <div
                    class="nav-item"
                    :class="{ active: activeTab === item.key }"
                    @click="handleClick(item)"
                >
                    <img :src="$asset(item.icon)" :alt="$t('mobileNav.' + item.key)" class="nav-icon" />
                    <span class="nav-label">{{ $t('mobileNav.' + item.key) }}</span>
                </div>
                <div v-if="i < navItems.length - 1" class="nav-divider"></div>
            </div>
        </div>
    </nav>
</template>

<script>
// Items come from the `bottom.nav` extension point.
//   to          route to open
//   action      $root event to emit instead of navigating
//   loginFirst  guests get the login modal instead of the route
export default {
    name: 'MobileBottomNav',
    computed: {
        loggedIn() {
            return this.$sharedState.loggedIn;
        },
        navItems() {
            return this.$modules.items('bottom.nav', {
                loggedIn: this.loggedIn,
                memberInfo: this.$sharedState.memberInfo
            });
        },
        activeTab() {
            const found = this.navItems.find(item => item.to && item.to === this.$route.path);
            return found ? found.key : 'home';
        }
    },
    methods: {
        handleClick(item) {
            if (item.action) {
                this.$root.$emit(item.action);
                return;
            }
            if (item.loginFirst && !this.loggedIn) {
                this.$root.$emit('open-login');
                return;
            }
            if (item.to && this.$route.path !== item.to) {
                this.$router.push(item.to);
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.mobile-bottom-nav {
    display: none;

    @media (max-width: 768px) {
        display: block;
        position: fixed;
        bottom: 8px;
        left: 8px;
        right: 8px;
        z-index: 200;
    }
}

.nav-inner {
    display: flex;
    align-items: center;
    padding: 8px 16px;
    background: linear-gradient(180deg, var(--surface-2) 0%, var(--surface-1) 46.63%, var(--surface-2) 100%);
    border: 1px solid var(--border-bright);
    border-radius: 16px;
    box-shadow: 0 0 12px color-mix(in srgb, var(--black) 80%, transparent), inset 0 0 34px 0 var(--glow);
}

.nav-item-wrap {
    flex: 1;
    display: flex;
    align-items: center;
}

.nav-item {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
    cursor: pointer;
    padding: 4px 0;
    border-radius: 8px;
    transition: background 0.2s;

    &.active {
        background: color-mix(in srgb, var(--glow) 25%, transparent);
    }
}

.nav-icon {
    width: 32px;
    height: 32px;
    object-fit: contain;
    display: block;
}

.nav-label {
    color: var(--text);
    font-size: 12px;
    font-weight: 700;
    text-align: center;
    line-height: 18px;
    white-space: nowrap;
}

.nav-divider {
    width: 1px;
    height: 48px;
    background: var(--border-accent);
    flex-shrink: 0;
}
</style>
